

<button class="btn btn-lg bg-white float-right" ><i class="align-middle fas fa-plus-circle"></i> Convert into Invoice </button>

<table class="neu-table table table-striped neu-table w-100 table-responsive" datatable [dtOptions]="dtOptions" data-page="2" ></table>